export const removeObjectProperties = (obj: any, props: string[]) => {
  for (const p of props) {
    delete obj[p];
  }
  return obj;
};
